import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const getAuthToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Save advertising content
export const saveAdvertisingContent = async (data) => {
  try {
    const response = await apiClient.post("/detectors/advertising-tools-save", data);
    return response.data;
  } catch (error) {
    console.error("Error saving advertising content:", error);
    throw error.response?.data || error;
  }
};

// Get advertising history
export const getAdvertisingHistory = async (userId, machineId, toolId = null) => {
  try {
    const response = await apiClient.post("/detectors/advertising-tools-history", {
      userId,
      machineId,
      toolId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching advertising history:", error);
    throw error.response?.data || error;
  }
};

// Get single saved content
export const getAdvertisingById = async (id, userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/advertising-tools/${id}?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching saved content:", error);
    throw error.response?.data || error;
  }
};

// Update saved content
export const updateAdvertisingContent = async (id, generatedContent, formattedContent, title) => {
  try {
    const response = await apiClient.put(`/detectors/advertising-tools-update/${id}`, {
      generatedContent,
      formattedContent,
      title,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating saved content:", error);
    throw error.response?.data || error;
  }
};

// Delete saved content
export const deleteAdvertisingContent = async (id) => {
  try {
    const response = await apiClient.delete(`/detectors/advertising-tools-delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting saved content:", error);
    throw error.response?.data || error;
  }
};

// Get statistics
export const getAdvertisingStats = async (userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/advertising-tools-stats?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error.response?.data || error;
  }
};